import Residences from "./Residences";
export default Residences;
